module.exports = __webpack_public_path__ + "img/tester-role01.4f732266.jpg";